import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const container = (theme: Theme) => css`
  position: relative;
  border: 1px solid ${theme.palette.warning[500]};
  border-radius: ${styles.borderRadius.sm};
  overflow: hidden;
  margin: ${styles.size[24]} 0;
`

export const content = css`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  padding: 0 ${styles.size[16]};
`
